/**
 * `data-` Animations
 * -----------------------------------------------------------------------------
 *
 * Add animations to elements using `data-` attributes.
 *
 * @todo Improve comments for this file authored by mStoner.
 */

const watch = () => {

  const targets = document.querySelectorAll( '[data-animate]:not([data-animate="true"])' );

  let done      = false;
  let delay     = 250;



  [ ...targets ].forEach( ( target ) => {

    if ( !done ) {

      const pos = target.getBoundingClientRect();

      if ( pos.top < window.innerHeight && pos.bottom > 0 ) {

        target.setAttribute( 'data-animate', 'true' );

        done  = true;
        delay = target.getAttribute( 'data-animation-delay' ) || delay;

      }

    }

  } );

  const time = done ? delay : 0;

  setTimeout( () => {
    requestAnimationFrame( watch );
  }, parseInt( time, 10 ) );

};

setTimeout( () => {
  watch();
}, 1000 );
